export default __webpack_public_path__ + "static/media/Steel City-3.dc9db2bc.jpg";